// extracted by mini-css-extract-plugin
export var emailBlockLink = "_p8-0";